<template>
  <div class="decorated-subtitle">
    <img class="img-responsive planet-pen-image" :src="planetPenImage" />
    <h3 class="text">{{ title }}</h3>
    <img class="img-responsive line-image" :src="lineImage" />
    <img class="img-responsive planet-image" :src="planetImage" />
  </div>
</template>

<script>
import SubTitle4 from "@/assets/homepage/sub-title-4.webp";
import FormeLigneIizenglishJaune11024x21 from "@/assets/homepage/forme-ligne-iizenglish-jaune-1-1024x21.webp";
import FormePlaneteIizenglishBleu from "@/assets/homepage/forme-planete-iizenglish-bleu.webp";
export default {
  name: "DecoratedSubtitle",
  props: {
    title: String,
  },
  data() {
    return {
      planetPenImage: SubTitle4,
      lineImage: FormeLigneIizenglishJaune11024x21,
      planetImage: FormePlaneteIizenglishBleu,
    };
  },
};
</script>

<style scoped lang="scss">
.decorated-subtitle {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 2em 2em 2em;

  .planet-pen-image {
    max-width: 90%;
  }

  .text {
    font-family: "Averia Sans Libre", sans-serif;
    margin: -0.5em 0px 20px 0px;
    font-size: 1.75em;
  }

  .line-image {
    max-width: 100%;
  }

  .planet-image {
    margin-top: 20px;
    max-width: 20%;
    position: relative;
    left: 20%;
  }
}
</style>
